(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'introAbout', {
            bindings: {
                content:    '<',
                subjects:   '<'
            },
            templateUrl:  'app/views/partials/content/intro-about.html',
            controller:   AboutIntroComponentController,
            controllerAs: 'vm',

            renderingOptions: {
                'intro-about': {
                    inputs:    [
                        'content="::content.asset_contents"' ,
                        'subjects="::content.subjects"'
                    ],
                    classes: [
                        'block-container',
                        'centraliser',
                        'two-col-layout',
                        'separated'
                    ]
                }
            }
        });


    /**
     * Introductory text with a list of subjects. Should be used
     * within a Study Areas exclusively.
     *
     * @param {ng.IScope} $scope
     * @param {Utils} Utils
     * @param {Object} CONFIG
     * @param {Object} TEXTS
     */
    function AboutIntroComponentController(
        $scope,
        Utils,
        CONFIG,
        TEXTS
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._        = TEXTS.AREA.ABOUT_INTRO;
        $scope.CONFIG   = CONFIG;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        vm.headingTooltips = Utils.getSharedContent().headingsToolTips.asset_contents;


    };


    AboutIntroComponentController.$inject = [ '$scope', 'Utils', 'CONFIG', 'TEXTS' ];
})();
